import React from "react";
import styles from "./PickADay.module.css";

interface PickADayWeekDayProps {
    item: string;
    id: number;
}

export const PickADayWeekDay: React.FC<PickADayWeekDayProps> = ({id, item}) => {
    return id < 5 ?
        (<div className={styles.PickADay__week_day}>
            {item}
        </div>) :
        (<div className={styles.PickADay__week_day_free}>
            {item}
        </div>)
}